module.exports = __webpack_public_path__ + "static/media/hafary.814ae5a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hafary.jpg
// module id = 1215
// module chunks = 1